/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";
import "../../App.css";
import { Button, Modal } from "antd";

class FoodFormatMessage extends Component<Props, State> {
    constructor(props: Props) {
        super(props);

        // this.api = "get_value_virtual_shop_messages"
    }

    componentDidMount() {
        if (this.props.content) {
            this.innerHtml(this.props.content);
        } else {
            setTimeout(() => {
                this.innerHtml(this.props.content);
            }, 500);
        }
    }

    componentDidUpdate(p) {
        if (p.content !== this.props.content) {
            this.innerHtml(this.props.content);
        }
    }

    getID = () => {
        return this.props.idStaticElement ? this.props.idStaticElement
            : this.props.animationType ? "food-format-message-animation-" + this.props.animationType
                : 'food-format-message'
    }

    innerHtml = (data) => {
        let id = document.getElementById(this.getID());

        if (id) {
            id.innerHTML = data;
            if (window.innerWidth < 1000) this.widthImgToMobile()
        } else {
            setTimeout(() => { this.innerHtml(data) }, 1000);
        }
    }

    widthImgToMobile = () => {
        let mElement = document.getElementById(this.getID())
        let imgElements = mElement.getElementsByTagName('img');
        let eCount = imgElements.length;
        for (let x = 0; x < eCount; x++) {
            imgElements[x].style.width = "95%";
            imgElements[x].style.height = "auto";
        }
        // console.log('mElement', mElement, imgElements.length)
    }

    render() {
        if (this.props.content) {
            if (this.props.idStaticElement) {
                return (<>
                    <div id={this.props.idStaticElement} />
                    {this.props.addToCartBtn ? <Button id={"food-format-message-add-button"} onClick={this.props.addToCartBtn}>הוסף לסל</Button> : ""}
                </>
                )
            } else if (this.props.animationType) {
                // console.log("food-format-message-animation-add-button", this.props.addToCartBtn)
                return (<div>
                    <div id={"food-format-message-animation-close"} onClick={this.props.onCancel}>x</div>
                    <div id={"food-format-message-animation-" + this.props.animationType} />
                    {this.props.addToCartBtn ? <div id={"food-format-message-animation-add-button"} onClick={this.props.addToCartBtn}>הוסף לסל</div> : null}
                </div>)
            } else {
                return (<Modal
                    footer={this.props.addToCartBtn ? [<Button id={"food-format-message-add-button"} onClick={this.props.addToCartBtn}>הוסף לסל</Button>] : false}
                    width={650} className={"padding_0"} visible={this.props.visible} onCancel={this.props.onCancel}>
                    <div id="food-format-message" />
                </Modal>)
            }
        } else {
            return ''
        }
    }

}
export default FoodFormatMessage;
